/**
 * Single tracking facade for the whole app — GTM is the only tag loader
 * (see public/index.html for the guarded GTM snippet). GA4, Meta Pixel and
 * Google Ads Conversion tags all live *inside* the GTM container (configured
 * in tagmanager.google.com), triggered off the dataLayer events pushed here.
 *
 * Do NOT call gtag()/fbq() directly from React — that would duplicate
 * whatever the GTM container already fires for the same event.
 *
 * All IDs are optional. Until the user adds REACT_APP_GTM_ID to the env,
 * every track() call safely no-ops (no dataLayer, no network request).
 */
const GTM_ID = process.env.REACT_APP_GTM_ID || "";
const validGtm = /^GTM-[A-Z0-9]+$/i;

export const trackingConfig = {
  gtmId: GTM_ID,
  hasGtm: validGtm.test(GTM_ID),
};

function getDataLayer() {
  if (!trackingConfig.hasGtm) return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

/** The only function application code should use to record analytics events. */
export function track(event, params = {}) {
  const dataLayer = getDataLayer();
  if (!dataLayer) return;
  dataLayer.push({ event, ...params });
}

export function trackPageView() {
  track("page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search,
  });
}

export function trackProductView(product) {
  if (!product) return;
  track("view_item", {
    items: [{ item_id: String(product.id), item_name: product.name, item_category: product.productTypeLabel }],
    content_ids: [String(product.id)],
    content_name: product.name,
    content_type: "product",
  });
}

export function trackSearch(searchTerm, resultCount) {
  track("search", {
    search_term: searchTerm,
    result_count: Number(resultCount || 0),
  });
}

export function trackWhatsAppClick({ placement, productId } = {}) {
  track("whatsapp_click", {
    placement: placement || "unknown",
    product_id: productId ? String(productId) : undefined,
  });
}
